import { callEdge } from "@/lib/edgeClient"

export interface LearningUser {
  id: string
  email: string
  created_at: string
  profile: any | null
}

export interface LearningStage {
  user_id: string
  drill_id: string
  learning_stage: 'cognitive' | 'associative' | 'autonomous'
  assessment_date: string
  confidence_score?: number
  performance_metrics?: Record<string, any>
  notes?: string
  created_at: string
  updated_at: string
  drill?: {
    id: string
    title: string
    module_id: string | null
  } | null
}

export interface LearningStagesResponse {
  stages: LearningStage[]
  total: number
}

export interface LearningDistribution {
  cognitive: number
  associative: number
  autonomous: number
  total: number
}

export interface LearningDistributionResponse {
  distribution: LearningDistribution
  percentages: {
    cognitive: number
    associative: number
    autonomous: number
  }
}

export interface BulkUpdateRequest {
  user_id: string
  updates: Array<{
    drill_id: string
    learning_stage: 'cognitive' | 'associative' | 'autonomous'
    confidence_score?: number
  }>
  reason?: string
}

export interface BulkUpdateResponse {
  success: boolean
  updated: number
  failed: number
  results: Array<{
    drill_id: string
    success: boolean
    data?: LearningStage
    error?: string
  }>
}

export async function searchLearningUser(email?: string, userId?: string): Promise<{ user: LearningUser }> {
  try {
    const params = email ? `email=${encodeURIComponent(email)}` : `user_id=${userId}`
    const data = await callEdge(`admin-learning-user?${params}`, {
      method: 'GET',
      authRequired: true,
    })
    return data as { user: LearningUser }
  } catch (error) {
    console.error('[searchLearningUser] Error:', error)
    throw error
  }
}

export async function getUserLearningStages(userId: string): Promise<LearningStagesResponse> {
  try {
    const data = await callEdge(`admin-learning-stages?user_id=${userId}`, {
      method: 'GET',
      authRequired: true,
    })
    return data as LearningStagesResponse
  } catch (error) {
    console.error('[getUserLearningStages] Error:', error)
    throw error
  }
}

export async function bulkUpdateLearningStages(request: BulkUpdateRequest): Promise<BulkUpdateResponse> {
  try {
    const data = await callEdge('admin-learning-stages-update', {
      method: 'POST',
      body: request,
      authRequired: true,
    })
    return data as BulkUpdateResponse
  } catch (error) {
    console.error('[bulkUpdateLearningStages] Error:', error)
    throw error
  }
}

export async function getLearningDistribution(userId: string): Promise<LearningDistributionResponse> {
  try {
    const data = await callEdge(`admin-learning-stages-distribution?user_id=${userId}`, {
      method: 'GET',
      authRequired: true,
    })
    return data as LearningDistributionResponse
  } catch (error) {
    console.error('[getLearningDistribution] Error:', error)
    throw error
  }
}





